document.addEventListener('click', function (event) {
  const trigger = event.target.closest('[is="open-mobile-drawer"]');

  if (!trigger) return;

  event.preventDefault();

  const menuButton = document.querySelector(
    'summary.header__icon--menu[on\\:click="/toggle"]'
  );

  if (menuButton) {
    menuButton.click();
  }
});

document.addEventListener('click', function (event) {
  const trigger = event.target.closest('[is="open-search-drawer"]');

  if (!trigger) return;

  event.preventDefault();

  const searchButton = document.querySelector(
    'button[on\\:click="#search-modal/showDialog"]'
  );

  if (searchButton) {
    searchButton.click();
  }
});


(function () {
  function syncMobileCart() {
    const mobileCart = document.querySelector(
      '#mobile-cart-icon-bubble'
    );

    const headerCart = document.querySelector(
      'cart-icon .cart-bubble'
    );

    if (!mobileCart || !headerCart) return;

    const countElement = headerCart.querySelector(
      '.cart-bubble__text-count'
    );

    const count = countElement
      ? parseInt(countElement.textContent.trim(), 10) || 0
      : 0;

    let bubble = mobileCart.querySelector('.cart-count-bubble');

    mobileCart.classList.toggle('is-empty-cart', count === 0);

    if (count === 0) {
      bubble?.remove();
      return;
    }

    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      bubble.innerHTML = `
        <span aria-hidden="true" data-total-cart-item></span>
        <span class="visually-hidden"></span>
      `;

      mobileCart.querySelector('.svg-wrapper')?.after(bubble);
    }

    bubble.querySelector('[data-total-cart-item]').textContent = count;

    bubble.querySelector('.visually-hidden').textContent =
      `${count} ${count === 1 ? 'item' : 'items'}`;
  }

  function initMobileCartSync() {
    const headerCart = document.querySelector('cart-icon');

    if (!headerCart) {
      console.warn('Horizon header cart not found');
      return;
    }

    const observer = new MutationObserver(syncMobileCart);

    observer.observe(headerCart, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true
    });

    syncMobileCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileCartSync);
  } else {
    initMobileCartSync();
  }
})();

document.addEventListener('click', function (event) {
  const trigger = event.target.closest('#mobile-cart-icon-bubble');

  if (!trigger) return;

  event.preventDefault();

  const cartButton = document.querySelector(
    '[on\\:click="#cart-drawer/toggle"]'
  );

  if (cartButton) {
    cartButton.click();
  }
});